import { render, staticRenderFns } from "./domainMgr.vue?vue&type=template&id=4f45d8d1&"
import script from "./domainMgr.vue?vue&type=script&lang=js&"
export * from "./domainMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports